import {useWatch} from 'react-hook-form'
import {useOrderProcessFormContext} from '../../form/useOrderProcessFormContext'
import {Contact, PhoneNumber} from '../../types'

export const useSiteContact = () => {
  const {control, setValue, trigger, formState: {defaultValues}} = useOrderProcessFormContext()
  const [name, phoneNumber] = useWatch({
    name: ['siteContact.name', 'siteContact.phoneNumber'],
    control
  })
  const defaultSiteContact = defaultValues?.siteContact
  const { name: defaultName, phoneNumber: defaultPhoneNumber } = defaultSiteContact ?? {}

  const setSiteContactName = (name: string) => {
    setValue('siteContact.name', name, {shouldValidate: true})
    trigger()
  }

  const setSiteContactPhoneNumber = (phoneNumber: PhoneNumber) => {
    setValue('siteContact.phoneNumber', phoneNumber, {shouldValidate: true})
    trigger()
  }

  const setSiteContact = (siteContact: Contact) => {
    setValue('siteContact', siteContact, {shouldValidate: true})
    trigger()
  }

  return {
    name,
    phoneNumber,
    defaultName,
    defaultPhoneNumber,
    setSiteContactName,
    setSiteContactPhoneNumber,
    setSiteContact
  }
}
